/**
 *
 * StepChip
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Text } from '@cashfree-intl/coherent';

function StepChip(props) {
  return (
    <div className="step-chip">
      <Text variant="b12" color="white" strong>
        {props.children}
      </Text>
    </div>
  );
}

StepChip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(StepChip);
